export default __webpack_public_path__ + "static/media/hollywood-night.fc2edef5.svg";